import { Box } from "@mui/material";
import { useEffect, useState } from "react";

// Import specific menus
import { useAuthProvider } from "../../auth/hooks/auth-provider";
import { UserType } from "../../models/UserType";
import { zoullooColors } from "../../theme";
import FreelancerMenu from "../menus/FreelancerMenu";
import InternalMenu from "../menus/InternalMenu";
import ClientMenu from "../menus/ClientMenu";
import { getStorageItem } from "../../hooks/useEnvironmentStorage";
import { UserRole } from "../../models/UserRole";
import { useLocation } from "react-router-dom";

const Sidebar: React.FC = () => {
	const [isCollapsed, setIsCollapsed] = useState<boolean>(false); // Ouvert par défaut
	const drawerWidth = isCollapsed ? 50 : 285;
	// Use auth provider to get user info from token (no API call)
	const { user, isAuthenticated, isLoading } = useAuthProvider();
	const location = useLocation();

	useEffect(() => {
		if (!user || !user.externalId) return;

		// Use externalId for storage key since id comes from API
		const storageKey = `zoulloo_menu_collapsed_user_${user.externalId}`;
		const savedCollapseState = getStorageItem(storageKey);

		if (savedCollapseState === null) return;

		const isStoredCollapsed = savedCollapseState === "true";

		if (isStoredCollapsed !== isCollapsed) {
			setIsCollapsed(isStoredCollapsed);
		}
	}, [user]);

	return !isLoading && isAuthenticated && user ? (
		<Box
			sx={{
				position: "sticky",
				top: 0
			}}
			zIndex={3}
			height={"100vh"}
		>
			<Box
				sx={{
					paddingBottom: "20px",
					borderRadius: "16px", // Round all 4 corners
					overflow: "hidden",
					backgroundColor: zoullooColors.background.default,
					width: drawerWidth,
					height: "100%",
					transition: "width 0.3s ease", // Smooth transition when collapsing
					"& .css-1wvake5": {
						borderRight: "none !important"
					},
					"& .pro-sidebar-inner": {
						background: `${zoullooColors.background.default} !important`,
						paddingBottom: "40px",
						borderRight: "none !important"
					},
					"& .pro-icon-wrapper": {
						backgroundColor: "transparent !important"
					},
					"& .pro-inner-item": {
						padding: "5px 35px 5px 20px !important"
					},
					"& .pro-inner-item:hover": {
						color: `${zoullooColors.primary.main} !important`
					},
					"& .pro-menu-item.active": {
						color: `${zoullooColors.primary.main} !important`
					},
					"& .ps-active": {
						background: `${zoullooColors.background.disabled} !important`
					}
				}}
			>
				{(user.type === UserType.Freelancer ||
					(user.roles?.includes(UserRole.TAM) === true &&
						location.pathname.startsWith("/profile/"))) && (
					<FreelancerMenu
						isCollapsed={isCollapsed}
						setIsCollapsed={setIsCollapsed}
						drawerWidth={drawerWidth}
						user={user}
					/>
				)}
				{user.type === UserType.Client && (
					<ClientMenu
						isCollapsed={isCollapsed}
						setIsCollapsed={setIsCollapsed}
						drawerWidth={drawerWidth}
						user={user}
					/>
				)}
				{user.type === UserType.Internal &&
					!location.pathname.startsWith("/profile/") && (
						<InternalMenu
							isCollapsed={isCollapsed}
							setIsCollapsed={setIsCollapsed}
							drawerWidth={drawerWidth}
							user={user}
						/>
					)}
			</Box>
		</Box>
	) : (
		<></>
	);
};

export default Sidebar;
